import { useQuery } from '@tanstack/react-query';

import { INBOX_API_KEY } from '@/src/components/project/Inbox2/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { QUICKBOOKS_BASE_URL } from '.';

import { AutomatedDraftResponse, DraftResponse } from '../types/draft';

const url = `${QUICKBOOKS_BASE_URL}/:documentId/drafts`;

export type GetDraftsResponse = DraftResponse[] | AutomatedDraftResponse[];

export const treatmentDraftsQueryKey = (documentId: UseGetDraftsOptions['documentId']) => [
  INBOX_API_KEY,
  'drafts',
  documentId,
];

export const getDrafts = (documentId: number): Promise<GetDraftsResponse> => {
  return axios.get(generateRoutePath(url, { documentId }));
};
type QueryFnType = typeof getDrafts;

type UseGetDraftsOptions = {
  documentId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetDrafts = ({ documentId, config }: UseGetDraftsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...treatmentDraftsQueryKey(documentId)],
    queryFn: () => getDrafts(documentId),
    staleTime: Infinity,
    ...config,
  });
};
